import { useNotificationStore } from "@/stores/notification";

export default {
  install(app) {
    const storeGetter = () => useNotificationStore();

    // funcția generică
    app.config.globalProperties.$notify = (options) => {
      const store = storeGetter();
      store.notify(options);
    };

    // alias helper cu titlu implicit
    const makeNotify = (type, defaultTitle) => (options) => {
      const store = storeGetter();
      store.notify({
        type,
        title: options.title || defaultTitle,
        message: options.message,
        timeout: options.timeout ?? 4000
      });
    };

    // alias-uri scurte
    app.config.globalProperties.$info = makeNotify("info", "Succes");
    app.config.globalProperties.$warning = makeNotify("warning", "Atenție");
    app.config.globalProperties.$error = makeNotify("critical", "Eroare");
  }
};
